<div class="payment-actions-buttons">
    @if (editable) {
        <button id="edit-cart-button" class="mat-body-2 px-0" mat-button color="primary" (click)="edit()">
            <span>Edit</span>
        </button>
    }
    <button
        class="mat-body-2 px-0"
        id="delete-cart-button"
        mat-button
        color="primary"
        (click)="removePayment(paymentRequest)"
    >
        @if (!isLoading) {
            <span>Delete</span>
        }
        @if (isLoading) {
            <mat-icon class="ms-2 spinner-icon" color="error">
                <mat-spinner diameter="20" color="error"></mat-spinner>
            </mat-icon>
        }
    </button>
</div>
